import { useParams } from 'wouter';
import { Tabs } from '@platform/components';
import { TeamsResultsTab } from './TeamsResultsTab';
import { AdminTeams } from '@platform/client';
import { FreeAgentsResultsTab } from './FreeAgentsResultsTab';
import { useState } from 'react';
import { CreateTeamModal } from './modals/CreateTeamModal';
import { AdminTeamMember } from '@platform/client/schemas';
import { EditMembersModal } from './modals/EditMembersModal';
import { AdminListPageWrapper } from '../../AdminListPage';

export const CohortTeams = () => {
  const { cohortId: cohortIdParam } = useParams<{ cohortId: string }>();
  const cohortId = parseInt(cohortIdParam);
  const [createTeamModalOpen, setCreateTeamModalOpen] = useState({
    isOpen: false,
    inComingMembers: undefined as undefined | AdminTeamMember[],
  });
  const [editMembersModalOpen, setEditMembersModalOpen] = useState<{
    isOpen: boolean;
    teamId: undefined | number;
    incomingNewMembers: undefined | AdminTeamMember[];
  }>({ isOpen: false, teamId: undefined, incomingNewMembers: undefined });
  const { data } = AdminTeams.useGetTeamsCounts({ cohort_id: cohortId });
  return (
    <AdminListPageWrapper title={data?.cohortName || 'Cohort Results'}>
      <Tabs
        title='Results'
        items={[
          {
            id: 'Teams',
            actionCount: data?.teamsCount || undefined,
            content: (
              <TeamsResultsTab
                cohortId={cohortId}
                setCreateTeamModalOpen={setCreateTeamModalOpen}
                setEditMembersModalOpen={setEditMembersModalOpen}
              />
            ),
          },
          {
            id: 'Free Agents',
            actionCount: data?.freeAgentsCount || undefined,
            content: (
              <FreeAgentsResultsTab
                cohortId={cohortId}
                setCreateTeamModalOpen={setCreateTeamModalOpen}
                setEditMembersModalOpen={setEditMembersModalOpen}
              />
            ),
          },
        ]}
      />
      {createTeamModalOpen.isOpen && (
        <CreateTeamModal
          cohortId={cohortId}
          onClose={() => setCreateTeamModalOpen({ isOpen: false, inComingMembers: undefined })}
          incomingMembers={createTeamModalOpen.inComingMembers}
        />
      )}
      {editMembersModalOpen.isOpen && editMembersModalOpen.teamId && (
        <EditMembersModal
          teamId={editMembersModalOpen.teamId}
          cohortId={cohortId}
          incomingNewMembers={editMembersModalOpen.incomingNewMembers}
          onClose={() =>
            setEditMembersModalOpen({
              isOpen: false,
              teamId: undefined,
              incomingNewMembers: undefined,
            })
          }
        />
      )}
    </AdminListPageWrapper>
  );
};
